import DatePickerIsValid from '../../../../components/Inputs/DatePickerIsValid';
import DefaultModal from '../../../../components/Modal/DefaultModal';
import React, { useCallback, useEffect, useState } from 'react';
import { Row, Form, Col, Button, Input } from 'reactstrap';
import FormTooltip from 'components/Inputs/FormTooltip';
import { ErrorMessage } from '@hookform/error-message';
import FlexSelect from 'components/Inputs/FlexSelect';
import { useForm, Controller } from 'react-hook-form';
import UserService from '../../../User/service';
import OverTimesService from '../../service';
import ReactLoader from 'components/Loader';
import { toast } from 'react-toastify';
import * as styles from './styled';

const ModalExtraHour = ({
  isModalOpen,
  onModalToggle,
  reloadfunction,
  id,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  const { control, handleSubmit, errors, setValue, reset, watch } = useForm();
  const [isBeforeStart, setIsBeforeStart] = useState(false);
  const [supervisorLogin, setSupervisorLogin] = useState();
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [supervisors, setSupervisors] = useState([]);
  const [showUsers, setShowUsers] = useState(false);
  const [timeValue, setTimeValue] = useState('');
  const [timeError, setTimeError] = useState('');
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (id) {
      setLoading(true);
      loadApi();
    }
  }, [id, loadApi, isModalOpen]);

  useEffect(() => {
    setTimeError('');
    setTimeValue('');
  }, [isModalOpen]);

  useEffect(() => {
    const Params = {
      page: 0,
      size: 0,
      showDisable: true,
      query: '',
      isSupervisor: true
    };

    UserService.getAllShowSupervisor(
      Params.page,
      Params.size,
      Params.query,
      Params.showDisable,
      Params.isSupervisor
    ).then((response) => {
      const login = localStorage.getItem('login');
      const username = localStorage.getItem('name');
      const listSupervisors = response.data.data.map((user) => {
        if (login === user.login && username === user.name) {
          setSupervisorLogin(login);
          setIsSupervisor(true);
          setShowUsers(true);
        }
        return {
          label: user.name,
          value: user.login
        };
      });
      setSupervisors(listSupervisors);
    });

    UserService.getAll(false, undefined, undefined, false)
      .then((response) => {
        const listUsers = response.data.data
          .filter(
            (user) =>
              !supervisors.some((supervisor) => supervisor.value === user.login)
          )
          .map((user) => {
            return {
              label: user.name,
              value: user.login
            };
          });
        setUsers(listUsers);
      })
      .catch((error) => {
        toast.error(error.response?.data.errors[0]);
      });
  }, [isModalOpen]);

  const loadApi = useCallback(async () => {
    OverTimesService.get(id).then((response) => {
      const getOverTime = response.data.data;
      const getOverTimeFormated = {
        ...getOverTime,
        date: toISORender(getOverTime.date),
        supervisor: getOverTime.supervisor.login
      };
      setIsBeforeStart(getOverTimeFormated.isBeforeStart);
      reset(getOverTimeFormated);
      setLoading(false);
    });
  }, [id]);

  const dateRules = {
    required: 'Data é obrigatório!',
    pattern: {
      value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
      message: 'Data inválida! (dd/MM/aaaa)'
    }
  };
  const toISORender = (dateNotFormmated) => {
    if (dateNotFormmated === undefined) {
      //
    } else {
      const [date] = dateNotFormmated.split('T');
      const [YYYY, MM, DD] = date.split('-');
      return `${DD}/${MM}/${YYYY}`;
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const onSubmit = async (data) => {
    const FormatDate = toISOFormat(data.date);
    const FormatData = {
      ...data,
      date: FormatDate,
      timeInMinutes: timeValue,
      isFromSupervisor: isSupervisor,
      supervisor: isSupervisor ? supervisorLogin : data.supervisor
    };
    if (id) {
      await OverTimesService.put(id, FormatData)
        .then(() => {
          toast.info('Hora extra atualizada com sucesso!');
        })
        .catch((err) => toast.error(err.response?.data.errors[0]))
        .finally(() => {
          onModalToggle(false);
          reloadfunction();
        });
    } else {
      await OverTimesService.post(FormatData)
        .then(() => {
          toast.info('Hora extra cadastrada com sucesso!');
        })
        .catch((err) => toast.error(err.response?.data.errors[0]))
        .finally(() => {
          onModalToggle(false);
          reloadfunction();
        });
    }
  };

  const toISOFormat = (dateNotFormmated) => {
    if (dateNotFormmated === undefined) {
      toast.error('Error: A data está vazia!');
    } else {
      const [date] = dateNotFormmated.split(' ');
      const [DD, MM, YYYY] = date.split('/');
      return `${YYYY}-${MM}-${DD}T03:00:00.000Z`;
    }
  };

  const verifyMinutes = (minutes) => {
    const value = Number(minutes);
    if (!minutes) return 'Insira a quantidade de minutos';
    if (Number.isNaN(value)) return 'Insira um número válido';
    if (value <= 0) return 'Insira uma quantidade de minutos válida';
    if (value > 120) return 'A quantidade de minutos deve ser inferior a 120';
    return '';
  };

  const selectedUser = watch(showUsers ? 'user' : 'supervisor');

  const isSubmitDisabled = !timeValue || !!timeError || !selectedUser;

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Solicitação de Hora Extra"
      showCloseButton={false}
      modalContainerClasses="modal-sm"
      {...props}
    >
      <>
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <Row className="justify-content-md-center">
              <ReactLoader />
            </Row>
          ) : (
            <>
              <Row className="mb-3">
                <Col>
                  <label className="form-control-label">Data</label>
                  <Controller
                    render={(props) => (
                      <DatePickerIsValid
                        fieldName="date"
                        valueController={setValue}
                        defaultValue={props.value}
                      />
                    )}
                    control={control}
                    name="date"
                    rules={dateRules}
                    defaultValue={new Date().toLocaleDateString('pt-br')}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="date"
                    render={({ message }) => errorFormMessage(message)}
                  />
                  <div style={styles.divFlexAlignMargin24_4}>
                    <div style={styles.divFlex1Align}>
                      <span
                        className="form-control-label"
                        style={styles.spanFormControlLabelTime(timeError)}
                      >
                        Tempo (minutos) <span style={{ color: 'red' }}>*</span>
                      </span>
                    </div>
                    <FormTooltip
                      text="A restrição de 2 horas existe porque, conforme o artigo 59 da Consolidação das Leis do Trabalho (CLT), a jornada diária de trabalho somente pode ser acrescida de até duas horas extras, desde que haja acordo individual, acordo coletivo ou convenção coletiva. Dessa forma, o sistema foi configurado para cumprir o limite legal padrão previsto em lei. Caso seja necessária a realização de um número superior de horas extras em situações excepcionais, o colaborador deverá entrar em contato com seu supervisor ou gestor responsável para alinhar previamente com a empresa, conforme as regras internas e os acordos aplicáveis."
                      style={styles.formTooltip}
                    />
                  </div>
                  <div style={styles.divMarginBottom4MaxWidth320}>
                    <Input
                      name="timeInMinutes"
                      value={timeValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        setTimeValue(value);
                        setTimeError(verifyMinutes(value));
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) setTimeError('');
                      }}
                      style={styles.inputTimeInMinutes(timeError)}
                      autoComplete="off"
                    />
                  </div>
                  {timeError && (
                    <div style={styles.divErrorTime}>
                      <span style={styles.spanErrorIcon}>!</span>
                      <span style={styles.spanErrorText}>{timeError}</span>
                    </div>
                  )}
                  <div style={styles.divFlexAlignMargin24_4_2}>
                    <div style={styles.divFlex1Align_2}>
                      <span className="form-control-label">
                        {showUsers ? 'Usuário' : 'Supervisor'}{' '}
                        <span style={{ color: 'red' }}>*</span>
                      </span>
                    </div>
                  </div>
                  <div style={styles.divMarginBottom16MaxWidth320}>
                    <Controller
                      render={(props) => (
                        <FlexSelect
                          dataOptions={showUsers ? users : supervisors}
                          isClearable={true}
                          closeMenuOnSelect={true}
                          isMulti={false}
                          value={props.value}
                          valueController={setValue}
                          fieldName={showUsers ? 'user' : 'supervisor'}
                          labelName="label"
                          valueName="value"
                          defaultValue=""
                          styles={{
                            container: (base) => ({ ...base, width: '100%' })
                          }}
                        />
                      )}
                      control={control}
                      name={showUsers ? 'user' : 'supervisor'}
                      rules={{ required: 'Campo obrigatório' }}
                      defaultValue=""
                    />
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="supervisor"
                    render={({ message }) => errorFormMessage(message)}
                  />
                  <div style={styles.divFlexAlignMargin24_4_3}>
                    <div style={styles.divFlex1Align_3}>
                      <span
                        className="form-control-label"
                        style={styles.spanFormControlLabelExpediente}
                      >
                        Hora extra antes do expediente
                      </span>
                      <Controller
                        render={(props) => (
                          <input
                            onChange={(e) => {
                              props.onChange(e.target.checked);
                            }}
                            type="checkbox"
                            className="checkbox"
                            name="isBeforeStart"
                            defaultChecked={isBeforeStart}
                            style={styles.inputCheckbox}
                          />
                        )}
                        control={control}
                        name="isBeforeStart"
                        defaultValue={false}
                      />
                    </div>
                    <div style={styles.divFlexJustifyEnd}>
                      <FormTooltip text="Habilitando este campo a hora extra do usuário será antes do expediente, caso o campo esteja desabilitado e hora extra será após seu expediente." />
                    </div>
                  </div>
                </Col>
              </Row>
              <hr />
              <Button
                color="primary"
                type="submit"
                disabled={isSubmitDisabled}
                style={styles.buttonPrimary(isSubmitDisabled)}
              >
                Salvar
              </Button>

              <Button color="danger" onClick={closeModal}>
                Voltar
              </Button>
            </>
          )}
        </Form>
      </>
    </DefaultModal>
  );
};

export default ModalExtraHour;
